import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-decline",
  "use": "icon-decline-usage",
  "viewBox": "0 0 20 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 12\" fill=\"none\" id=\"icon-decline\"><path id=\"icon-decline_Path\" fill-rule=\"evenodd\" style=\"fill:#D05E5E\" transform=\"translate(0 0)  rotate(0 10 6)\" opacity=\"1\" d=\"M0 1.41L1.41 0L7.41 6L11.41 2L17.71 8.29L20 6L20 12L14 12L16.29 9.71L11.41 4.83L7.41 8.83L0 1.41Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol